import axios from "axios";
import { message } from "antd";
import { API } from "../config/config";

export const api = axios.create({
  baseURL: API,
});

const getToken = () => localStorage.getItem("token");

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      message.error({
        content: "Сессия истекла. Пожалуйста, войдите снова.",
        onClose: () => {
          window.location.href = "/login";
        },
      });
    }
    return Promise.reject(error);
  }
);

// API функция для скачивания Excel файла с деталями оборота
export const downloadTurnoverDetailsExcel = async (comparisonDate?: string) => {
  try {
    const params: any = {};
    if (comparisonDate) {
      params.comparisonDate = comparisonDate;
    }

    const response = await api.get("/stats/turnover/excel", {
      responseType: "blob",
      params,
    });
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    
    // Получаем имя файла из заголовков ответа или используем значение по умолчанию
    const contentDisposition = response.headers["content-disposition"];
    let filename = "turnover_details.xlsx";
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch && filenameMatch.length === 2) {
        filename = filenameMatch[1];
      }
    }
    
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    message.success("Excel файл успешно скачан!");
  } catch (error) {
    console.error("Error downloading turnover Excel:", error);
    message.error("Ошибка при скачивании Excel файла");
    throw error;
  }
};

export const listTurnoverDetailsExcelReports = async (): Promise<{
  reports: Array<{ date: string; fileName: string; sizeBytes: number; createdAtMs: number }>;
}> => {
  const response = await api.get("/stats/turnover/excel/reports");
  return response.data;
};

export const downloadSavedTurnoverDetailsExcelReport = async (date: string) => {
  try {
    const response = await api.get(`/stats/turnover/excel/reports/${date}`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;

    const contentDisposition = response.headers["content-disposition"];
    let filename = `turnover_details_${date}.xlsx`;
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch && filenameMatch.length === 2) {
        filename = filenameMatch[1];
      }
    }

    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    message.success("Excel файл успешно скачан!");
  } catch (error) {
    console.error("Error downloading saved turnover Excel:", error);
    message.error("Ошибка при скачивании Excel файла");
    throw error;
  }
};

export const generateTurnoverDetailsExcelReport = async (options?: {
  date?: string;
  force?: boolean;
  comparisonDate?: string;
}) => {
  const params: any = {};
  if (options?.date) params.date = options.date;
  if (options?.force) params.force = "true";
  if (options?.comparisonDate) params.comparisonDate = options.comparisonDate;

  const response = await api.post("/stats/turnover/excel/reports/generate", null, { params });
  return response.data as {
    status: "created" | "regenerated" | "skipped";
    date: string;
    fileName: string;
    sizeBytes: number;
    createdAtMs: number;
  };
};
